import { IAutoMapper } from "../../core/automapper/interfaces";
import { StringHelper } from "../../utilities/contracts/string-helper";

export const mapCodThreshold = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "CodThreshold")
    .forMember("projectId", o => o.projectId)
    .forMember("projectName", o => o.projectName)
    .forMember("codThreshold", o => o.codThreshold);
};

export class CodThreshold {
  projectId?: number;
  projectName?: string;
  codThreshold?: number;

  constructor(options: Partial<CodThreshold> = {}) {
    this.projectId = options.projectId;
    this.projectName = StringHelper.clean(options.projectName);
    this.codThreshold = options.codThreshold;
  }
}
